<template>
  <section id="landing" class="landing">
    <div
      class="bg"
      :style="`
              background: url('${staticUrl}/images/design-studio/ds-main-bg.webp');
              background-repeat: no-repeat;
              background-position: top;
              background-size: cover;
            `"
    />
    <div class="bg__blackout"></div>
    <!-- <DesignStudioBgVideo class="bg" /> -->
    <div class="info-box">
      <div class="info-box__title">
        {{ $t('DStudioMainTitle') }}
      </div>
      <div class="info-box__subtitle">
        <span>{{ $t('DStudioMainSubtitle1') }}</span>
        <span>{{ $t('DStudioMainSubtitle2') }}</span>
      </div>
      <div class="info-box__btn-wrapper">
        <ui-button
          :size="ButtonSizeType.large"
          :label="$t('DStudioMainBtn')"
          color="primary-offer"
          ref="btnRef"
          class="dwnload-btn btn btn_lg"
          @click="actionHandler"
        >
          <template v-if="!isMobile" #before></template>
        </ui-button>
      </div>
    </div>
  </section>
</template>

<script setup lang="ts">
import {useBaseStore} from '~/modules/BaseModule/base.store';
import {ButtonSizeType} from '~/interfaces/ui/button';
import {useDesignStudioStore} from '~/store/design-studio.store';

const runtimeConfig = useRuntimeConfig();
const staticUrl = runtimeConfig.public.vueAppStaticUrl;
const base = useBaseStore();
const designStudio = useDesignStudioStore();
const isMobile = computed(() => base.isMobile);
const route = useRoute();
const emits = defineEmits(['designRequest']);

const actionHandler = () => {
  if (route.path.includes('d-studio')) {
    designStudio.btnCreateHandlerForLanding();
  } else {
    emits('designRequest');
  }
};
</script>

<style scoped lang="scss">
.landing {
  width: 100%;
  height: 100%;
  min-height: calc(100vh - 60px);
  display: flex;
  justify-content: flex-start;
  align-items: center;

  .info-box {
    width: 1080px;
    display: flex;
    justify-content: flex-start;
    align-items: flex-start;
    flex-direction: column;
    gap: $g-1;

    &__before {
      color: var(--var-white-000);
      font-size: $fs-18;
      margin-bottom: $mb-2;
    }
    &__title {
      color: #fff;
      font-family: Segoe UI;
      font-size: 68px;
      font-style: normal;
      font-weight: 700;
      line-height: 110%; /* 79.2px */
      max-width: 60vw;
      display: flex;
      flex-direction: column;

      span {
        width: fit-content;
      }

      @media (max-width: 1550px) {
        max-width: 75vw;
      }
      @media (max-width: $lg) {
        font-size: 48px;
        max-width: 100vw;
        display: inline-block;
      }

    }
    &__subtitle {
      @include paragraphy-p1;
      display: flex;
      flex-direction: column;
      margin-top: $m-6;
      margin-bottom: $m-8;
      color: #fff;
      text-align: center;
      max-width: 60vw;
      font-weight: 400;
      text-align: left;
      @media (max-width: $lg) {
        font-size: 20px;
        letter-spacing: 0.6px;
        letter-spacing: 0.6px;
        margin-bottom: $m-8;
        max-width: 70vw;
      }
      @media (max-width: $md) {
        margin-top: $m-5;
        margin-bottom: $m-4;
        max-width: 90vw;
      }
    }

    &__btn-wrapper {
      display: flex;
      gap: $g-4;
      width: 100%;

      @media (max-width: $md) {
        flex-direction: column;
        width: 100%;
      }
    }
    .btn {
      max-width: 340px;
      width: 100%;
      margin-top: 16px;
      font-size: 24px;
      font-weight: 600;
      line-height: 24px; /* 133.333% */
      letter-spacing: 0.36px;

      @media (max-width: $md) {
        max-width: 100%;
      }
    }

    .dwnload-btn {
      padding: 16px 64px;
      height: 56px;
      max-width: 300px;

      @media (max-width: $md) {
        max-width: unset;
      }
    }

    .btn_lg {
      padding: 16px 60px !important;
      svg {
        min-width: 20px;
      }
    }
    .mobile-btn {
      display: none;
    }
  }

  @media (min-width: 2000px) {
    min-height: 1000px;
  }
}
.bg {
  position: absolute;
  left: 0;
  top: 60px;
  width: 100vw;
  height: calc(100vh - 60px);
  z-index: -1;

  background-repeat: no-repeat;
  background-position: top;
  background-size: cover;
  @media (min-width: 2000px) {
    height: 1000px;
  }
  @media (max-width: $md) {
    background-position: left;
  }
}
.bg {
  position: absolute;
  left: 0;
  top: 60px;
  width: 100%;
  height: calc(100vh - 60px);
  z-index: -1;

  @media (min-width: 2000px) {
    height: 1000px;
  }
  @media (max-width: $md) {
    background-position: left;
  }

  &__blackout {
    background-color: #09152da6;
    position: absolute;
    left: 0;
    top: 60px;
    width: 100%;
    height: calc(100vh - 60px);
    z-index: -1;

    @media (min-width: 2000px) {
      height: 1000px;
    }
  }
}
</style>
